import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {Integrations} from "./integration.type";
import {firstValueFrom} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class IntegrationsService {
    
    constructor(
        private httpClient: HttpClient, 
        ){}

    async integrations() {
        return await firstValueFrom(this.httpClient.get<Integrations>('/integration'));
    }

    async test(name: string) {
        return await firstValueFrom(this.httpClient.get('/integration/test/' + name));
    }

    async toggle(name: string) {
        return await firstValueFrom(this.httpClient.put('/integration/toggle/' + name, {}));
    }

    async remove(name: string) {
        return await firstValueFrom(this.httpClient.delete('/integration/remove/' + name));
    }

    async invite(name: string) {
        return await firstValueFrom(this.httpClient.post('/integration/invite/' + name, {}));
    }
}